import { fetch } from 'utils/redux/action'

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_CRYPTO_MOSTWANTED = 'FETCH_CRYPTO_MOSTWANTED'
export const RECEIVE_CRYPTO_MOSTWANTED = 'RECEIVE_CRYPTO_MOSTWANTED'

// ------------------------------------
// Actions
// ------------------------------------
export const actionTypes = {
	fetch: FETCH_CRYPTO_MOSTWANTED,
	receive: RECEIVE_CRYPTO_MOSTWANTED
}

// ------------------------------------
// Thunk
// ------------------------------------
export const fetchCryptoMostWanted = () => fetch('cryptoMostWanted', 'cryptomostwanted', actionTypes)
